/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const COPY_LINK_PATH =
  'M10 17.55L8.23002 19.27C7.76589 19.7341 7.1364 19.9948 6.48002 19.9948C5.82364 19.9948 5.19415 19.7341 4.73002 19.27C4.26589 18.8058 4.00515 18.1763 4.00515 17.52C4.00515 16.8636 4.26589 16.2341 4.73002 15.77L9.27002 11.22C9.71563 10.7729 10.316 10.5143 10.947 10.4975C11.578 10.4807 12.1913 10.7072 12.66 11.13L12.78 11.23C12.9696 11.4156 13.2253 11.5183 13.4906 11.5155C13.756 11.5127 14.0094 11.4046 14.195 11.215C14.3807 11.0253 14.4834 10.7697 14.4806 10.5044C14.4778 10.239 14.3696 9.98562 14.18 9.79997C14.1236 9.727 14.0635 9.65691 14 9.58997C13.1464 8.84729 12.0424 8.45682 10.9116 8.49767C9.78082 8.53852 8.70785 9.00763 7.91002 9.80997L3.31002 14.36C2.52838 15.2108 2.10564 16.3306 2.13009 17.4857C2.15455 18.6408 2.6243 19.7418 3.44125 20.5587C4.2582 21.3757 5.35918 21.8454 6.51427 21.8699C7.66935 21.8944 8.78923 21.4716 9.64002 20.69L11.37 19C11.5408 18.8136 11.6347 18.5695 11.6328 18.3167C11.6309 18.0639 11.5333 17.8212 11.3597 17.6375C11.1861 17.4537 10.9494 17.3426 10.6971 17.3263C10.4448 17.3101 10.1958 17.39 10 17.55ZM20.69 3.30997C19.8488 2.47398 18.711 2.00476 17.525 2.00476C16.339 2.00476 15.2012 2.47398 14.36 3.30997L12.63 4.99997C12.4592 5.18632 12.3653 5.43045 12.3672 5.68324C12.3691 5.93603 12.4667 6.17871 12.6403 6.36246C12.8139 6.54621 13.0507 6.65739 13.303 6.67362C13.5552 6.68986 13.8043 6.60995 14 6.44997L15.73 4.72997C16.1941 4.26584 16.8236 4.0051 17.48 4.0051C18.1364 4.0051 18.7659 4.26584 19.23 4.72997C19.6941 5.1941 19.9549 5.8236 19.9549 6.47997C19.9549 7.13635 19.6941 7.76584 19.23 8.22997L14.69 12.78C14.2444 13.227 13.644 13.4857 13.013 13.5024C12.382 13.5192 11.7687 13.2928 11.3 12.87L11.18 12.77C10.9904 12.5843 10.7348 12.4816 10.4694 12.4844C10.2041 12.4872 9.95067 12.5953 9.76502 12.785C9.57937 12.9746 9.47665 13.2302 9.47946 13.4956C9.48228 13.7609 9.59039 14.0143 9.78002 14.2C9.85266 14.2743 9.92945 14.3444 10.01 14.41C10.8647 15.1504 11.9682 15.5394 13.0983 15.4986C14.2284 15.4578 15.301 14.9902 16.1 14.19L20.65 9.63997C21.4913 8.80405 21.9678 7.6692 21.9753 6.48322C21.9828 5.29724 21.5207 4.15646 20.69 3.30997Z';

const VIEWBOX_SIZE = 24;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Copy link / chain-link (24×24 asset).
 * Color via `currentColor` — set via CSS `color` property or `ds-icon--color-*` utility.
 * Pass `aria-label` when the icon conveys meaning without adjacent visible text.
 */
const CopyLinkIcon = ({
  size = 24,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={COPY_LINK_PATH} fill="currentColor" />
  </svg>
);

CopyLinkIcon.propTypes = iconPropTypes;

export { CopyLinkIcon };
export default CopyLinkIcon;
